import { ChangeDetectionStrategy, Component, ElementRef, inject, signal, WritableSignal } from '@angular/core';
import { Router } from '@angular/router';
import {
  ActivitySectionDirective,
  IMenuWithPages,
  MenuImageComponent,
  MenusService,
  UserActivityClickTrackingDirective,
} from '@core';
import { toSignal } from '@angular/core/rxjs-interop';
import { tap } from 'rxjs/operators';
import { TranslatePipe } from '@ngx-translate/core';
import { HeaderComponent, PageHeaderBackSwipeConfig } from '@app/components/header/header.component';
import { ScrollComponent } from '@app/components/scroll/scroll.component';

@Component({
  selector: 'app-page-special-offer',
  templateUrl: './special-offer.component.html',
  styleUrls: ['./special-offer.component.scss'],
  imports: [
    UserActivityClickTrackingDirective,
    ActivitySectionDirective,
    MenuImageComponent,
    TranslatePipe,
    HeaderComponent,
    ScrollComponent,
  ],
  host: {
    'class': 'page',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SpecialOfferComponent {

  private readonly elementRef = inject<ElementRef<HTMLElement>>(ElementRef);
  private readonly router = inject(Router);
  private readonly menus = inject(MenusService);

  protected readonly backSwipeConfig: PageHeaderBackSwipeConfig = {
    element: this.elementRef.nativeElement,
  };

  public activeMenu: WritableSignal<IMenuWithPages | undefined> = signal<IMenuWithPages | undefined>(undefined);

  public readonly specialMenus = toSignal(this.menus.getMenuForCurrentMedia().pipe(
    tap((menus) => {
      if (!menus) {
        this.router.navigate(['/main', 'home']);
      }
      if (menus && menus.length === 1) {
        this.activeMenu.set(menus[0]);
      }
    }),
  ));

}
